import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { hideNotificationDialogEmergencyOrder } from "redux/actions/notificationEmergencyOrderActions"
import { useDispatch, useSelector } from "react-redux";
import { Button, DialogActions, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
 import {  useNavigate } from "react-router-dom";
import success from "assets/images/success.png"
import warning from "assets/images/warning.png"
import failed from "assets/images/failed.png"
import { PAGE } from "./CONSTANTS";

export default function AlertDialogEmergencyOrder(props) {
  const dispatch = useDispatch();
   const navigate = useNavigate();
  const { isShowing, title, content, button } = useSelector(
    (state) => state.EmergencyOrderNotification
  );

  const handleClose = (event, reason) => {
    
    event.preventDefault();
    if(title === "Submitted Successfully"){
      navigate(PAGE.UPLOAD_EMERGENCY_ORDERS.url);
   dispatch(hideNotificationDialogEmergencyOrder());
    }else {
      dispatch(hideNotificationDialogEmergencyOrder());
    } 
  
  };

  return (
    <div>
      <Dialog
        maxWidth="sm"
        fullWidth={true}
        open={isShowing}
        onClose={handleClose}
        aria-labelledby="title"
        aria-describedby="description"
      >
        <DialogTitle id="title" sx={{fontWeight: 'bold'}}>
        { 
          title.includes('Status') ?
        <img style={{height:'25px',color: "#108810", marginRight:'12px',paddingTop:'8px'}} src={warning} alt="warning"></img>: title.includes('Successful')?<img style={{height:'25px',color: "#108810", marginRight:'12px',paddingTop:'8px'}} src={success} alt="success"></img>:title.includes('Failed')?<img style={{height:'25px',color: "#108810", marginRight:'12px',paddingTop:'8px'}} src={failed} alt="failed"></img>:''
 }
          {title}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="description">{content}</DialogContentText>
        </DialogContent>

        <DialogActions sx={{ pl: 3, pb: 3, justifyContent: "flex-start" }}>
          <Button variant="contained" color="primary" onClick={handleClose}>
            {button}
          </Button>
        </DialogActions>

      </Dialog>
    </div>
  );
}
